import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi, I'm <span className="purple">Muhammad Ismaeel</span>, a{" "}
            <span className="purple">Full Stack Software Engineer</span> based
            in <span className="purple">KPK,Pakistan</span>.
            <br />
            <br />

            I specialize in building scalable web and desktop applications using{" "}
            <span className="purple">
              React.js, Next.js, Node.js, Express.js, PostgreSQL, Prisma ORM,
              TypeScript
            </span>{" "}
            and <span className="purple">Electron.js</span>.

            <br />
            <br />

            I enjoy transforming complex business requirements into fast,
            reliable, and maintainable software. My interests include modern web
            development, REST API design, database architecture, performance
            optimization, and building clean, reusable application
            architectures.

            <br />
            <br />

            I earned my{" "}
            <span className="purple">
              BS in Computer Science (2019–2023)
            </span>{" "}
            from{" "}
            <a
              className="purple"
              href="https://aust.edu.pk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Abbottabad University of Science and Technology
            </a>.
          </p>

          <div style={{ textAlign: "left", marginTop: "30px" }}>
            <h2>Professional Experience</h2>

            <br />

            <h4 className="purple">
              Full Stack Software Engineer — Devsort Services
            </h4>

            <p>
              <strong>Nov 2023 – May 2026</strong>
            </p>

            <ul>
              <li>
                Designed and developed scalable web and desktop applications
                using React.js, Next.js, Node.js, Express.js, PostgreSQL, Prisma
                ORM, and Electron.js.
              </li>

              <li>
                Developed a Vendor Management System using Electron.js and
                SQLite3.
              </li>

              <li>
                Built an AI Interview Buddy platform using Next.js and Flask.
              </li>

              <li>
                Designed REST APIs and integrated secure backend services.
              </li>

              <li>
                Successfully delivered production-ready applications including
                Guidana, Nova CRM, BNBPulse, Growthware, and Trading Bot.
              </li>

              <li>
                Collaborated within Agile teams, optimized application
                performance, and maintained production deployments.
              </li>
            </ul>

            <br />

            <h4 className="purple">
              Web Developer — Stellar Stack
            </h4>

            <p>
              <strong>May 2022 – Apr 2023</strong>
            </p>

            <ul>
              <li>
                Developed responsive React.js and Next.js applications.
              </li>

              <li>
                Improved UI performance and implemented reusable component
                architecture.
              </li>

              <li>
                Integrated Contentful CMS and modern UI libraries including
                Material UI and Tailwind CSS.
              </li>
            </ul>
          </div>

          <blockquote
            style={{
              marginTop: "30px",
              color: "rgb(155 126 172)",
              fontStyle: "italic",
            }}
          >
            "Building software isn't just writing code—it's solving real
            problems through thoughtful engineering."
          </blockquote>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;